import React from "react";
import "./History_Table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";
import { Dropdown, Form } from "react-bootstrap";

const payoutData = [
  {
    date: "20 Jan 2026",
    transactionId: "WD982341",
    amount: 1500,
    method: "Bank Transfer",
    status: "Completed",
  },
  {
    date: "18 Jan 2026",
    transactionId: "WD982341",
    amount: 500,
    method: "Bank Transfer",
    status: "Processing",
  },
  {
    date: "17 Jan 2026",
    transactionId: "WD982341",
    amount: 1500,
    method: "Bank Transfer",
    status: "Rejected",
  },
  {
    date: "16 Jan 2026",
    transactionId: "WD982341",
    amount: 500,
    method: "Bank Transfer",
    status: "Processing",
  },
  {
    date: "15 Jan 2026",
    transactionId: "WD982341",
    amount: 1500,
    method: "Bank Transfer",
    status: "Rejected",
  },
  {
    date: "14 Jan 2026",
    transactionId: "WD982341",
    amount: 500,
    method: "Bank Transfer",
    status: "Processing",
  },
  {
    date: "13 Jan 2026",
    transactionId: "WD982341",
    amount: 1500,
    method: "Bank Transfer",
    status: "Completed",
  },
];

const PayoutHistory = () => {
  const getStatusColor = (status) => {
    if (status === "Completed") return "#1aa64b";
    if (status === "Rejected") return "#ff0000";
    if (status === "Processing") return "#000000";
    return "#333";
  };

  return (
    <section className="history-table-section">
      <div className="payout-wrapper">
        <div className="payout-card">
          <div className="payout-header">
            <h5>Recent Pay Out History</h5>
            <Dropdown align="end">
              {/* <Dropdown.Toggle
                as="span"
                className="filter-text"
                style={{ cursor: "pointer" }}
              >
                Filter:
                <FontAwesomeIcon
                  className="filter-icon ms-1"
                  icon={faSliders}
                />
              </Dropdown.Toggle> */}

              <Dropdown.Menu className="custom-dropdown-menu">
                {/* Date Range */}
                <div className="dropdown-section">
                  <h6 className="dropdown-title">Date Range</h6>
                  <div className="check-list">
                    <Form.Check type="radio" label="Today" name="date" />
                    <Form.Check type="radio" label="Last 30 Days" name="date" />
                    <Form.Check type="radio" label="Custom Range" name="date" />
                  </div>
                </div>

                {/* <div className="dropdown-divider-custom"></div> */}

                {/* Status */}
                <div className="dropdown-section">
                  <h6 className="dropdown-title">Status</h6>
                  <div className="check-list">
                    <Form.Check type="radio" label="All" name="status" />
                    <Form.Check type="radio" label="Processing" name="status" />
                    <Form.Check type="radio" label="Completed" name="status" />
                    <Form.Check
                      type="radio"
                      label="Rejected / Failed"
                      name="status"
                    />
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            {/* <span className="filter-text">
              Filter:
              <FontAwesomeIcon className="filter-icon" icon={faSliders} />
            </span> */}
          </div>

          <div className="table-responsive">
            <table className="payout-table">
              <thead>
                <tr className="table-heading">
                  <th>Date</th>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                  <th>Method</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {payoutData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date}</td>
                    <td>{item.transactionId}</td>
                    <td>₹{item.amount.toLocaleString()}</td>
                    <td>{item.method}</td>
                    <td
                      style={{
                        color: getStatusColor(item.status),
                        fontWeight: "600",
                      }}
                    >
                      {item.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PayoutHistory;
